import Cookies from 'js-cookie';

import makeModal from '@/views/modal/make_modal';

let modal = null;

// otherwise the modal is taken into the turbolinks snapshot and revives on a restore visit
$(document).on('turbolinks:before-cache', () => {
  modal?.destroy();
  modal = null;
});

$(document).on('turbolinks:load', () => {
  const node = document.getElementById('modal_tariff_selection');
  if (!node) { return; }

  const { agreements, detailsText } = JSON.parse(node.dataset.props);

  modal = makeModal({
    cssClass: 'b-modal-tariff is-tariff-selection',
    silhouette: null,
    importComponent: async () => await import('@/vue/modals/tariff_selection'),
    props: {
      agreements,
      detailsText,
      'onDetails:click': rememberDismissedAgreement
    },
    onHide: () => agreements.forEach(({ cookieKey }) => rememberDismissedAgreement(cookieKey))
  });

  modal.show();
});

function rememberDismissedAgreement(cookieKey) {
  Cookies.set(cookieKey, '1', { expires: 1, path: '/' });
}
